import "../../pages/Home/home.scss";
import React from 'react'
import Side from "../../components/sidebar/Side.jsx"
import NavBar from "../../components/navbar/NavBar.jsx"
import Contenedor from "../../components/cartas/Contenedor.jsx"
 


const Home = () => {
 
  return (
    <>

    <div className='home'>
          <Side/>
          <div className="homeContainer">
            <div className="widgets">
          <Contenedor/>
            </div>
          </div>
      </div>
    

    </>
  )
}

export default Home
